<template>
    <div class="collapse-body pb-0">
        <csp-form-group-checkbox as-switch :form="customerForm" hide-label label-property="isCompanyCarForCustomer"
            property="gender" unchecked-value="" value="company"/>

        <csp-create-customer-form :customer-form="customerForm" :is-fleet-or-major-customer="isFleetOrMajorCustomer"/>
    </div>
</template>

<script>
    import CreateCustomerByCustomerForm from '@csp-app/views/recordByCustomer/form/CreateCustomerForm';
    import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';
    import GenderEnum from '../../../../lib/enums/GenderEnum';
    import {buildOptionsGenderPerson} from '@js/functions/form/select';

    export default {
        components: {
            'csp-create-customer-form': CreateCustomerByCustomerForm,
        },
        props: {
            isFleetOrMajorCustomer: {
                type: Boolean,
                required: false,
                default: false,
            },
            recordForm: {
                type: RecordCreateForm,
                required: true,
            },
        },
        data() {
            return {
                genderOptions: [],
            }
        },
        computed: {
            customerForm() {
                return this.recordForm.getSubform('customer');
            },
            isGenderCompany() {
                return this.customerForm.getDataOfProperty('gender') === GenderEnum.COMPANY;
            },
            isCustomerGenderSelected() {
                var customerData = this.customerForm.getData();
                return customerData.gender !== '';
            },
        },
        async mounted() {
            this.genderOptions = await buildOptionsGenderPerson();
        },
    }
</script>
